module.exports = __webpack_public_path__ + "img/triangle-outline.cbd524b4.svg";